/**
 * Production-safe logger utility
 * Only logs in development mode (when not minified/bundled for production)
 */

const isDev = typeof process !== 'undefined' && process.env?.NODE_ENV === 'development';

// Check if we're in a dev environment by looking for common indicators
const isDevEnvironment = () => {
  if (typeof window === 'undefined') return false;

  // Check for localhost or common dev ports
  const hostname = window.location?.hostname || '';
  const port = window.location?.port || '';

  return (
    isDev ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('.local') ||
    port === '5173' || // Vite
    port === '3000' || // React dev server
    port === '8080'    // Common dev port
  );
};

const devMode = isDevEnvironment();

export const logger = {
  log: (...args) => {
    if (devMode) console.log(...args);
  },
  warn: (...args) => {
    if (devMode) console.warn(...args);
  },
  error: (...args) => {
    // Always log errors, they're important
    console.error(...args);
  },
  info: (...args) => {
    if (devMode) console.info(...args);
  },
  debug: (...args) => {
    if (devMode) console.debug(...args);
  },
  // Force log even in production (use sparingly)
  force: (...args) => {
    console.log(...args);
  }
};

export default logger;
